<template>
  <div class="search-container">
    <!-- 搜索栏 -->
    <!--
      Tips: 在 van-search 外层增加 form 标签，且 action 不为空，即可在 iOS 输入法中显示搜索按钮
     -->
    <form action="/">
      <van-search
        v-model="searchText"
        placeholder="请输入搜索关键词"
        show-action
        @search="onSearch(searchText)"
        @cancel="$router.back()"
        @focus="isResultShow = false"
      />
    </form>
    <!-- /搜索栏 -->

    <!-- 搜索结果 -->
    <result-list
    v-if="isResultShow"
    :search-text="searchText"
    ></result-list>
  </div>
</template>

<script>
import ResultList from './components/result-list'
export default {
  name: 'SearchIndex',
  components: {
    ResultList
  },
  props: {},
  data () {
    return {
      searchText: '', // 搜索输入框的内容
      isResultShow: false, // 控制搜索结果的显示状态
      results: [] // 搜索结果数组
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    onSearch (searchText) {
      // 判断空字符串?
      this.searchText = searchText
      this.isResultShow = true
    }
  }
}
</script>

<style lang="less" scoped>
.search-container {
  width: 100%;
  box-sizing: border-box;
  /deep/ .van-search {
    padding-right: 5px;
    .van-search__content {
      margin-right: 5px;
    }
    .van-search__action {
      padding-left: 2px;
    }
  }
}
</style>
